import BlogPageCard from '@/components/blog/BlogPageCard';
import React from 'react';
import { useRouter } from 'next/router';
import { useFetchBlogPosts } from '@/useQuery/queries/blogs';
import strapiConstants from '@/constants/strapi.constants';

export default function RelatedBlogs({ blogtitle }: { blogtitle: string }) {
  // Hol dir den aktuellen Locale aus dem Router
  const router = useRouter();
  const locale = router.locale || 'en';

  // Fetch Blogposts mithilfe deines Custom-Hooks
  const blogsQuery = useFetchBlogPosts(
    strapiConstants.queries.Articles_3,
    locale
  );

  // Ladezustand und Fehler abdecken
  if (blogsQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (blogsQuery.isError) {
    return <div>Error loading blogs</div>;
  }

  // Daten holen
  const blogs = blogsQuery.data || [];
  const filteredBlogs = blogs.filter(
    (blog) => blog.attributes.title !== blogtitle
  );
  const limitedBlogs = filteredBlogs.slice(0, 3);

  return (
    <div className="">
      <div className="tw-flex tw-gap-8 child:tw-basis-[calc(33.33%-1rem)] max-sm:tw-flex-col">
        {blogs.length === 0 ? (
          <div>No related blogs found.</div>
        ) : (
          limitedBlogs.map((blog) => <BlogPageCard key={blog.id} blog={blog} />)
        )}
      </div>
    </div>
  );
}
